// 时间戳转xxxx-xx-xx格式的日期
export const timestampToDate = (timestamp, type = false) => {
  let fullTime = new Date(timestamp)
  let year = fullTime.getFullYear()
  let month = (fullTime.getMonth() + 1) < 10 ? '0' + (fullTime.getMonth() + 1) : (fullTime.getMonth() + 1)
  let day = (fullTime.getDate()) < 10 ? '0' + (fullTime.getDate()) : (fullTime.getDate())
  let hours = (fullTime.getHours()) < 10 ? '0' + (fullTime.getHours()) : (fullTime.getHours())
  let minutes = (fullTime.getMinutes()) < 10 ? '0' + (fullTime.getMinutes()) : (fullTime.getMinutes())
  let seconds = (fullTime.getSeconds()) < 10 ? '0' + (fullTime.getSeconds()) : (fullTime.getSeconds())
  return type === false ? `${year}-${month}-${day}` : `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
}

//  获取当前时间
export const getCurrentTime = () => {
  const date = new Date()// 当前时间
  const year = date.getFullYear() // 年
  const month = zeroFill(date.getMonth() + 1) // 月
  const day = zeroFill(date.getDate()) // 日
  const hour = zeroFill(date.getHours()) // 时
  const minute = zeroFill(date.getMinutes()) // 分
  const second = zeroFill(date.getSeconds()) // 秒

  // 当前时间
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`
}
// 随机密码数
export function randStr(len) {
  len = len || 32
  const $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz'
  const maxPos = $chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos)) //charAt() 方法可返回指定位置的字符。floor() 方法返回小于等于x的最大整数。random() 方法可返回介于 0 ~ 1 之间的一个随机数
  }
  return pwd
}

//清空数组中的空字符串
export function deleteNullString(arr) {
  for (var i = 0; i < arr.length; i++) {
    if (arr[i] == '' || arr[i] == null || typeof (arr[i]) == undefined) {
      arr.splice(i, 1);
      i = i - 1;
    }
  }
  return arr
}
//获取字符串的宽度
export function getTextWidth(text, font) {
  // re-use canvas object for better performance
  var canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement('canvas'))
  var context = canvas.getContext('2d')
  context.font = font
  var metrics = context.measureText(text)
  return metrics.width
}



// WEBPACK FOOTER //
// ./src/utils/tools.js